
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { AlertifyService } from "../../../services/core/alertify.service";
import { CustomerService } from "../../../services/customer/customer.service";
import { AuthService } from "../../../services/auth.service";
import { OrderEntity } from "../../../models/entity/order/order.entity";
import { Address } from "../../../models/entity/address";
import { NoteSelectComponent } from "../../core/note-select/note-select.component";
import { OrderService } from "../../../services/order/order.service";
import { ServiceCar } from "../../../models/entity/serviceCar";
import { CustomerDetailDto } from "../../../models/dto/customerDetailDto";
import { OrderWithItemsDto } from "../../../models/dto/orderWithItemsDto";
import { OrderItemWithDetailDto } from "../../../models/dto/orderItemWithDetailDto";
import { TranslateService } from "@ngx-translate/core";
import { OrderStatusEnum } from "../../../enum/status/order-status.enum";
import { NoteCategoryEnum } from "../../../enum/note-category.enum";
import { SmsMessageTypeEnum } from "../../../enum/sms/sms-message-type.enum";
import { SelectedItemIdDto } from "../../../models/dto/selectedItemIdDto";
import { AllowedStoreTypeEnum } from "../../../enum/type/allowed-store-type.enum";
import { DateFormatEnum } from "../../../enum/date-format.enum";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AddressAddUpdateComponent } from "../../../pages/customer/address-add-update/address-add-update.component";
import { ModalSizeEnum } from "../../../enum/modal-size.enum";
import { AddressListComponent } from "../../../pages/customer/address-list/address-list.component";
import { OrderUtilsService } from "../../../services/order/order-utils.service";
import { SessionStorageService } from "../../../services/session-storage.service";
import { DeviceLocalStorageData } from "../../../models/rest/user/device-local-storage-data.model";
import { OrderPrintUtilsService } from "../../../services/order/order-print-utils.service";
import { StoreCacheService } from "../../../services/cache/store-cache.service";
import { CustomerEntity } from "../../../models/entity/customer/customer.entity";
import { StoreSettingEntity } from "../../../models/entity/store/store-setting.entity";
import { StringUtils } from "../../../utils/string.utils";
import { GeneralUtils } from "../../../utils/general.utils";
import { firstValueFrom } from "rxjs";
import { DateUtils } from "../../../utils/date.utils";
import { NumberUtils } from "../../../utils/number.utils";
import { CustomerDetailRequest } from "../../../models/rest/customer/customer-detail-request.model";




@Component({
  selector: "app-order-pickup-add",
  templateUrl: "./order-pickup-add.component.html",
  styleUrls: ["./order-pickup-add.component.css"],
})
export class OrderPickupAddComponent implements OnInit {
  @Input() customerId: number = 0;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  currentUserId: number;
  //Sipariş bilgisi
  order: OrderEntity = new OrderEntity();
  address: Address = new Address();

  //Müşteri bilgileri
  customerDetailDto: CustomerDetailDto = new CustomerDetailDto();

  orderWithItem: OrderWithItemsDto;
  orderItems: OrderItemWithDetailDto[] = [];
  serviceCars: ServiceCar[];
  storeSetting: StoreSettingEntity;
  stores: SelectedItemIdDto[] = [];
  dateFormatEnum = DateFormatEnum;
  isSendSms: boolean = false;
  isSendSmsForServiceCar: boolean = false;
  isPrintReceipt: boolean = true;
  receiptCount: number = 1;
  deviceLocalStorageData: DeviceLocalStorageData;
  isBusy: boolean = false;

  constructor(
    private orderUtilsService: OrderUtilsService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private customerService: CustomerService,
    private alertifyService: AlertifyService,
    private authService: AuthService,
    private orderService: OrderService,
    private storeCacheService: StoreCacheService,
    private orderPrintUtilsService: OrderPrintUtilsService,
    private sessionStorageService: SessionStorageService,
  ) { }

  async ngOnInit() {
    this.deviceLocalStorageData = this.sessionStorageService.getDeviceStorageData();
    this.customerDetailDto.customer = new CustomerEntity();
    this.customerDetailDto.address = new Address();
    this.isPrintReceipt = this.deviceLocalStorageData.isPrintReceiptForPickupOrder ?? false;

    this.createInitialOrder();
    //müşteri bilgilerini al
    this.getCustomerDetail();
    await this.getStores();
    this.onChangeStore();

  }

  onChangeStore() {
    this.getStoreSetting();
    this.getServiceCar();
  }

  async getStores() {
    try {
      const res = await this.storeCacheService.getStoreSelectList(this.authService.getStoreId(), AllowedStoreTypeEnum.ORDER).toPromise();
      this.stores = res ?? [];
    } catch (err) {
      this.alertifyService.error(err);
    }
  }


  //mağaza ayarlarını al
  getStoreSetting() {
    this.storeCacheService.getSetting(this.order.storeId).subscribe(
      res => {
        this.storeSetting = res;
        this.setOrderFieldsFromStoreSetting();
      },
      err => this.alertifyService.error(err)
    );
  }

  private createInitialOrder() {
    this.order = this.orderUtilsService.createNewOrder(this.authService.getStoreId(), this.customerId, 0, this.storeSetting)

  }


  setOrderFieldsFromStoreSetting() {

    this.order.orderStatusId = OrderStatusEnum.TAKE_FROM_ADDRESS;
    this.orderUtilsService.calculatePickupDate(this.order, this.storeSetting);
    this.order.isPickup = true;
    this.order.isDelivery = true;

    this.isSendSms = this.storeSetting.sendSmsForPickupOrder ?? false;
    this.isSendSmsForServiceCar = this.storeSetting.sendSmsForPickupOrderToServiceCar ?? false;

  }

  //Müşteri bilgileri alınır
  async getCustomerDetail() {

    try {
      const request = new CustomerDetailRequest();
      request.customerId = this.customerId;
      const res = await firstValueFrom(this.customerService.getCustomerDetail(request));
      this.customerDetailDto = res!.customerDetail!;
      this.address = this.customerDetailDto.address!;
    } catch (err) {
      this.alertifyService.error(err);
    }
  }



  // listeler
  getServiceCar() {
    this.storeCacheService.getServiceCars(this.order.storeId).subscribe(
      res => {
        this.serviceCars = res;
        this.order.serviceCarId = this.serviceCars[0].id;
      },
      err => {
        this.alertifyService.error(err);
      }
    );
  }
  async validateSave() {
    if (this.order.isDelivery && StringUtils.isEmpty(this.address.description)) {
      this.alertifyService.warning(this.translate.instant('message.warning.please-enter-address'));
      return false;
    }
    if (this.order.pickupDate == null) {
      this.alertifyService.warning(this.translate.instant('message.warning.please-select-pickup-date'));
      return false;
    }

    if (this.order.pickupDate < DateUtils.getToday()) {
      this.alertifyService.warning(this.translate.instant('message.warning.pickup-date-cannot-be-earlier-than-now'));
      return false;
    }

    if (NumberUtils.isNotGreaterThanZero(this.order.serviceCarId)) {
      this.alertifyService.warning(this.translate.instant('message.warning.please-select-service-car'));
      return false;
    }

    return true;
  }

  //Siparişi oluştur
  async save() {

    try {
      this.isBusy = true;


      if (!await this.validateSave())
        return;

      this.order.pickupAddressId = this.address.id;
      this.order.deliveryAddressId = this.address.id;

      this.orderWithItem = new OrderWithItemsDto();
      this.orderWithItem.order = this.order;
      this.orderWithItem.orderItems = this.orderItems;

      const res = await firstValueFrom(this.orderService.createOrMofifyOrder(this.orderWithItem));
      this.orderWithItem = res;
      this.alertifyService.success(this.translate.instant('order.orderCode') + ':' + this.orderWithItem.order.orderCode);

      this.sendSmsToService();
      this.sendSmsToCustomer();
      if (this.isPrintReceipt)
        this.printReceipt(this.orderWithItem.order.id);

      this.passEntry.emit({ order: this.orderWithItem.order, saved: true });
      this.activeModal.close();
    } catch (err) {
      this.alertifyService.error(err);
    } finally {
      this.isBusy = false;
    }

  }

  private sendSmsToService() {
    if (!this.isSendSmsForServiceCar) return;

    this.orderService.sendOrderSms(this.orderWithItem.order.id!, SmsMessageTypeEnum.SEND_ORDER_INFO_TO_SERVICE_CAR).subscribe(
      data => {
        this.alertifyService.success(this.translate.instant('message.info.sms-has-been-sent-to-the-service-car'));
      },
      err => {
        this.alertifyService.error(err);
      }
    );
  }



  private sendSmsToCustomer() {
    if (!this.isSendSms) return;
    this.orderService.sendOrderSms(this.orderWithItem.order.id!, SmsMessageTypeEnum.ORDER_PICKUP).subscribe(
      data => {
        this.alertifyService.success(this.translate.instant('message.info.sms-has-been-sent-to-customer'));
      },
      err => {
        this.alertifyService.error(err);
      }
    );
  }

  openUpdateAddress() {
    const modalRef = this.modalService.open(AddressAddUpdateComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.LARGE
    });

    //modal  veri geçişi
    modalRef.componentInstance.data = GeneralUtils.clone(this.address);

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if (receivedEntry) {
        this.address = receivedEntry;
      }

      // modal kapat
      modalRef.close();
    });
  }

  chooseAddress() {
    const modalRef = this.modalService.open(AddressListComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.XLARGE
    });

    //modal  veri geçişi
    modalRef.componentInstance.customerId = this.customerId;

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if (receivedEntry) {
        this.address = receivedEntry;
        this.order.pickupAddressId = receivedEntry.id;
      }

      // modal kapat
      modalRef.close();
    });
  }

  // Siparişe not ekle
  openSelectOrderNote() {

    const modalRef = this.modalService.open(NoteSelectComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.LARGE
    });

    //modal  veri geçişi
    modalRef.componentInstance.noteCategoryId = NoteCategoryEnum.ORDER_NOTE;
    modalRef.componentInstance.notes = this.order.notes;

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if (receivedEntry) {
        this.order.notes = receivedEntry;
      }

      // modal kapat
      modalRef.close();
    });


  }

  async printReceipt(orderId) {
    try {

      await this.orderPrintUtilsService.printReceipt(orderId, 1);
    }
    catch (err) {
      this.alertifyService.error(err);
    }
  }


  close() {
    this.activeModal.close();
  }
}
